var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('Info',{staticClass:"col-12"}),_c('PhotoSelector',{staticClass:"col-12"}),_c('Search',{staticClass:"col-md-12"}),_c('UploadHistory',{staticClass:"col-12"})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }